import React, { useState } from 'react'
import { gsColors } from '../../styles/Variables'
import { mq } from '../../helpers'
import SignInModal from './AuthModal'
import { isAuthenticated } from '../../services/Authenticator'
import { Text } from '../../styles/Components'
import styled from '@emotion/styled'

const SignInTextContainer = styled.div`
  margin: 66px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mq('max', '768px')} {
    margin: 32px 0 0;
  }

  p {
    ${mq('max', '768px')} {
      font-size: 14px !important;
    }

  }
  
  button {
    border: none;
    background-color: transparent;
    color: ${gsColors.sunsetOrange};
    font-family: Euclid;
    font-size: 18px;
    font-weight: 600;
    line-height: 138%;
    letter-spacing: 0.72px;
    
    ${mq('max', '768px')} {
      font-size: 14px !important;
    }

    &:hover {
      cursor: pointer;
    }
  }
`

/* SignInText 
  * displays text to signin and redirects to login and takes you back to the page you were on 
  */
export default function SignInText({
  dispatch,
  showSignInLink = true,
  disabled = false,
  children,
  isDesktop
}) {
  // state for controlling visibility of sign-in modal
  const [isSignInModalOpen, setSignInModalOpen] = useState(false)
  const closeSignInModal = () => {
    //dispatch authentication in case of a sign in for rerendering (for step 3 autofill)
    if (dispatch) {
      dispatch({ isAuthenticated: isAuthenticated() })
    }
    setSignInModalOpen(false)
  }

  const openSignInModal = () => setSignInModalOpen(true)

  if (isAuthenticated()) {
    return null
  }

  return (
    <SignInTextContainer>
      <Text
        fontSize={18}
        lineHeight='138%'
        align='center'
        spacing={0.72}
      >
        {children}
      </Text>
      {showSignInLink && (
        <button
          disabled={disabled}
          onClick={openSignInModal}
        >
          Sign in
        </button> 
      )}
      <SignInModal
        isOpen={isSignInModalOpen}
        close={closeSignInModal}
        isDesktop={isDesktop}
      />
    </SignInTextContainer>
  )
}
